import type { FC } from 'react';

import classNames from 'classnames';

import styles from './job_log.module.css';

type Props = {
  className?: string;
  message: string;
};

const JobLog: FC<Props> = ({ className, message }) => (
  <div className={classNames(styles.log, className)}>
    {message.split('\n').map((line, index) => (
      <div className={styles.log_line} key={index}>
        {line}
      </div>
    ))}
  </div>
);

export default JobLog;
